import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Layout from "../components/layout"
import DesktopMenu from "../components/DesktopMenu"
import {
  Card,
  Container,
  Grid,
  GridColumn,
  Header,
  Icon,
  Segment,
} from "semantic-ui-react"
import { navigate } from "@reach/router"
import JoinNewsletterModal from "../components/Shared/JoinNewsletterModal"

export default function BlogList() {
  const data = useStaticQuery(graphql`
    {
      allPrismicBlogPost(sort: { last_publication_date: DESC }) {
        totalCount
        nodes {
          url
          data {
            header_image {
              url
            }
            created_at
            author {
              id
              document {
                ... on PrismicAuthor {
                  uid
                  data {
                    name {
                      text
                      html
                    }
                    link {
                      url
                    }
                  }
                }
              }
            }
            title {
              text
            }
          }
        }
      }
    }
  `)

  const posts = data.allPrismicBlogPost.nodes
  const firstArticle = posts[0]

  const [screenWidth, setScreenWidth] = useState()
  const isMobile = screenWidth <= 760

  return (
    <Layout
      title={"Art Market News & Stories"}
      description={`Explore the latest art market news, in-depth artist profiles, and inspiring collector stories on ArtCollection.io's blog. Keep up-to-date and gain valuable insights into the art world.`}
      keywords={[
        "art market news",
        "art market stories",
        "art market blog",
        "art market articles",
        "art market insights",
        "art market trends",
        "art market analysis",
        "art market research",
        "art market reports",
        "art market data",
        "art market",
        "art collecting",
        "art collector stories",
        "art collector blog",
        "art collector articles",
      ]}
    >
      <DesktopMenu isMobile={isMobile} />
      <Grid stackable centered>
        <Grid.Row
          columns={1}
          style={{
            backgroundImage: `url(${firstArticle.data.header_image.url})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            padding: "0",
            cursor: "pointer",
          }}
          onClick={() => navigate(firstArticle.url)}
        >
          <GridColumn
            width={16}
            floated={"left"}
            style={{
              paddingLeft: "8em",
              paddingTop: "12em",
              paddingBottom: "8em",
              background:
                "linear-gradient(to right, rgba(0,0,0,1), rgba(0,0,0,0)",
            }}
          >
            <Container>
              <Header
                as={"h2"}
                size={"medium"}
                content={"Featured Article"}
                style={{ color: "#DFBD9A" }}
              />
              <Header
                as={"h1"}
                inverted
                size={"huge"}
                content={firstArticle.data.title.text}
                // subheader={firstArticle.excerpt}
              />
              <Header
                as={"h3"}
                inverted
                size={"small"}
                subheader={
                  firstArticle.data.author &&
                  firstArticle.data.author.document.data.name.text
                }
              />
              <div style={{ color: "#fff" }}>
                Read More <Icon name={"arrow right"} />
              </div>
            </Container>
          </GridColumn>
        </Grid.Row>
        <Grid.Row columns={1}>
          <Grid.Column>
            <Container>
              <Header size={"large"} content={"Featured Articles"} />
            </Container>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={1}>
          <Grid.Column>
            <Card.Group divided centered>
              {data.allPrismicBlogPost.nodes.map(
                ({
                  url,
                  data: { created_at, title, header_image, author },
                }) => (
                  <Card
                    onClick={() => navigate(url)}
                    image={header_image.url}
                    header={title.text}
                    meta={author && author.document.data.name.text}
                    description={new Date(created_at).toDateString()}
                  />
                ),
              )}
            </Card.Group>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={1} style={{ paddingBottom: "6em" }}>
          <Grid.Column textAlign={"center"}>
            <Segment style={{ marginLeft: "1em", marginRight: "1em" }}>
              <Header
                as={"h1"}
                size={"huge"}
                content={"Join Our Newsletter"}
                subheader={
                  "Stay up-to-date on the latest art market news, trends, and insights."
                }
              />
              <JoinNewsletterModal />
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Layout>
  )
}
